import { render } from "./TopBarButtons.vue?vue&type=template&id=4f0621a3"
import script from "./TopBarButtons.vue?vue&type=script&lang=js"
export * from "./TopBarButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TopBarButtons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f0621a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f0621a3', __exports__)) {
    api.reload('4f0621a3', __exports__)
  }
  
  module.hot.accept("./TopBarButtons.vue?vue&type=template&id=4f0621a3", () => {
    api.rerender('4f0621a3', render)
  })

}


export default __exports__